import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { RecentReports } from 'features/header/navigation/components/recent-reports';
import { selectMarketRecentReports } from 'store/header/navigation';
import { NavigationButtonProps, NavigationButtonWithPopover } from '../common';
import { useScrollToTopOnVisibilityChange } from 'features/header/navigation/hooks/navigation-hooks';
import { updatedMarketURLSignal } from 'features/insights/components/compare-bar/compare-bar-signals';

const marketLink = '/markets/';

export const Market = ({ label, isSelected, onClick }: NavigationButtonProps) => {
    const recentReports = useSelector(selectMarketRecentReports);
    const elementRef = useRef<HTMLUListElement>(null);
    const onVisibleChange = useScrollToTopOnVisibilityChange(elementRef);
    const { pathname, search } = useLocation();

    const handleLinkClick = (url: string) => {
        updatedMarketURLSignal.value = url;
    };

    const popoverContent = recentReports ? (
        <RecentReports
            recentReportsList={recentReports}
            reportsFor="market"
            onClick={onClick}
            onLinkClick={handleLinkClick}
            ref={elementRef}
        />
    ) : null;

    return (
        <NavigationButtonWithPopover
            link={pathname.startsWith(marketLink) ? `${pathname}${search}` : marketLink}
            label={label}
            popoverContent={popoverContent}
            isSelected={isSelected}
            onVisibleChange={onVisibleChange}
        />
    );
};
